import React, { useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import ReactPaginate from "react-paginate";
import Select from "react-select";
import Breadcrumb from "../components/Breadcrumb";
import ProjectService from "../services/ProjectService";
import VehicleRegistrationService from "../services/vehicleRegistrationService";
import VendorCategoryService from "../services/VendorCategoryService";
import VendorService from "../services/VendorServices";
import StorageService from "../services/StorageService";
import DailyFuelEntryService from "../services/DailyFuelEntryService";
import FuelPurchaseService from "../services/FuelPurchaseService";
import utility from "../utils/utility";
import { configSettings } from "../config/configSettings";
import usePermission from "../utils/UsePermission";
import ScreenData from "../config/ScreenData";
import MessageDialog from "../components/MessageDialog";

export default function AddDailyFuelEntry() {
  const [projects, setProjects] = useState([]);
  const [filterVehicles, setFilterVehicles] = useState([]);
  const [projectVehicles, setProjectVehicles] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [allActiveVehicles, setAllActiveVehicles] = useState([]);
  const [vendorCategories, setVendorCategories] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [entries, setEntries] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [filterVehicleId, setFilterVehicleId] = useState("");
  const [filterFromDate, setFilterFromDate] = useState("");
  const [filterToDate, setFilterToDate] = useState("");
  const [filteredEntries, setFilteredEntries] = useState([]);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("error");
  const [recentFuelRate, setRecentFuelRate] = useState(null);

  const {
    register,
    reset,
    watch,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",       //  LIVE validation
    reValidateMode: "onChange",
    defaultValues: {
      fuelSource: "EXTERNAL", // ✅ ADD THIS
    },
  });

  const vehicleWatch = watch("vehicleId");
  const vehicleTypeWatch = watch("vehicleTypeId");
  const fuelSourceWatch = watch("fuelSource");
  const fuelTypeWatch = watch("fuelType");
  const fuelQuantityWatch = watch("fuelQuantityLiters");
  const fuelEntryDateWatch = watch("fuelEntryDate");
  const [editData, setEditData] = useState(null);
  const [receiptPreview, setReceiptPreview] = useState(null);
  const [receiptPreviewOld, setReceiptPreviewOld] = useState(null);
  const previousFuelSourceRef = useRef("");
  const lastFuelSourceRef = useRef(null);
  const lastVehicleTypeRef = useRef(null);
  const emp = StorageService.loginData();
  const isSuperAdmin =
    emp.roleName === "Super Admin" ||
    emp.roleName === "SuperAdmin" ||
    Number(emp.roleId) === 1;
  const isAdmin = Number(emp.roleId) === 1 || Number(emp.roleId) === 2;


  const { permission, checkView, can } = usePermission(
    ScreenData.Daily_Fuel_Entry,
    setMessage
  );

  useEffect(() => {
    if (permission) {
      checkView();
    }
  }, [permission]);

  // useEffect(() => {
  //   if (message) {
  //     const timer = setTimeout(() => {
  //       setMessage("");
  //     }, 3000);

  //     return () => clearTimeout(timer);
  //   }
  // }, [message]);

  // useEffect(() => {
  //   if (vehicleWatch) {
  //     const selectedVehicle = vehicles.find(
  //       (v) => String(v.id) === String(vehicleWatch)
  //     );

  //     if (selectedVehicle) {
  //       const ownershipText = getOwnershipDisplay(selectedVehicle);
  //       setValue("ownerShipType", ownershipText);
  //     } else {
  //       setValue("ownerShipType", "");
  //     }
  //     setValue("fromReading", "");
  //   } else {
  //     setValue("ownerShipType", "");
  //     setValue("fromReading", "");
  //   }
  // }, [vehicleWatch, vehicles, setValue]);

  useEffect(() => {

    if (vehicleWatch) {

      const selectedVehicle = vehicles.find(
        (v) => String(v.id) === String(vehicleWatch)
      );

      if (selectedVehicle) {

        const ownershipText =
          getOwnershipDisplay(selectedVehicle);

        setValue("ownerShipType", ownershipText);

      } else if (!editData) {

        setValue("ownerShipType", "");
      }

      // ✅ clear only while adding
      if (!editData) {
        setValue("fromReading", "");
      }

    } else {

      setValue("ownerShipType", "");

      if (!editData) {
        setValue("fromReading", "");
      }
    }

  }, [vehicleWatch, vehicles, setValue, editData]);


  const getTodayDate = () => new Date().toISOString().split("T")[0];


  const loadProjects = async () => {
    const emp = StorageService.loginData();
    const comp = StorageService.activeCompany();

    try {
      let projectsData = [];

      // SUPER ADMIN → ALL COMPANY PROJECTS
      if (
        emp.roleName === "Super Admin" ||
        emp.roleName === "SuperAdmin" ||
        emp.roleName === "Data Admin" ||
        emp.roleName === "DataAdmin" ||
        Number(emp.roleId) === 1 ||
        Number(emp.roleId) === 2
      ) {
        const res = await ProjectService.getActive(comp.companyId);

        projectsData = (res || []).map(p => ({
          id: p.id,
          projectName: p.projectName,
          projectCode: p.projectCode,
        }));
      }
      //  NORMAL USER → ASSIGNED PROJECTS
      else {
        const res = await ProjectService.getAssignedProjects(
          comp.companyId,
          emp.employeeId
        );

        projectsData = (res?.data?.data || []).map(p => ({
          id: p.projectId,
          projectName: p.projectName,
          projectCode: p.projectCode,
        }));
      }

      setProjects(projectsData);
    } catch (err) {
      console.error("Error loading projects:", err);
      setProjects([]);
    }
  };

  const loadFilterVehicles = async (projectId) => {
    if (!projectId) {
      setFilterVehicles([]);
      return;
    }
    try {
      // includeReleased = true so we get all vehicles ever assigned to this project
      const res = await VehicleRegistrationService.getByProjectId(projectId, true);
      const list = res?.status ? res.data : res?.data || res || [];
      setFilterVehicles(list);
    } catch {
      setFilterVehicles([]);
    }
  };

  const filterVehicleOptions = useMemo(() => {
    const map = new Map();
    // 1. Add all vehicles assigned to this project (including released)
    filterVehicles.forEach((v) => {
      if (v?.id) {
        map.set(String(v.id), {
          id: v.id,
          vehicleName: v.vehicleName,
          registrationNo: v.registrationNo,
          vehicleType: v.vehicleType,
        });
      }
    });

    // 2. Also ensure any vehicle that exists in past fuel entries is present
    entries.forEach((e) => {
      if (e?.vehicleId && !map.has(String(e.vehicleId))) {
        map.set(String(e.vehicleId), {
          id: e.vehicleId,
          vehicleName: e.vehicleName || "Vehicle",
          registrationNo: e.registrationNo || `ID ${e.vehicleId}`,
          vehicleType: e.vehicleType || "",
        });
      }
    });

    return Array.from(map.values());
  }, [filterVehicles, entries]);

  const loadVehicles = async (projectId, targetDate = null) => {
    if (!projectId) {
      setProjectVehicles([]);
      return;
    }
    try {
      const dateToUse = targetDate || fuelEntryDateWatch || getTodayDate();
      const res = await VehicleRegistrationService.getByProjectId(projectId, false, dateToUse);
      const list = res?.status ? res.data : res?.data || res || [];
      setProjectVehicles(list);
    } catch {
      setProjectVehicles([]);
    }
  };

  const isVehicleInternal = (v) => {
    const ownership = v?.ownerShipType?.toLowerCase() || "";
    const fuelBy = v?.fuelBorneBy?.toLowerCase() || "";
    return (
      ownership === "self" ||
      ownership === "company" ||
      ownership === "other" ||
      fuelBy === "company"
    );
  };

  const getModalEligibleVehiclesList = () => {
    const isInternalSelected = fuelSourceWatch === "INTERNAL";

    // 1. Independent vehicles (NOT Lease and NOT Company): come from allActiveVehicles
    const independentVehicles = allActiveVehicles.filter((v) => {
      const ownership = v?.ownerShipType?.toLowerCase() || "";
      const isDependent = ownership === "lease" || ownership === "company";
      if (isDependent) return false; // Force Lease & Company vehicles to come strictly from projectVehicles

      const internalMatch = isVehicleInternal(v);
      return isInternalSelected ? internalMatch : !internalMatch;
    });

    // 2. Project-dependent vehicles (Lease or Company): MUST come from projectVehicles (respecting active project assignment dates)
    const dependentVehicles = projectVehicles.filter((v) => {
      const ownership = v?.ownerShipType?.toLowerCase() || "";
      const isDependent = ownership === "lease" || ownership === "company";
      if (!isDependent) return false;

      const internalMatch = isVehicleInternal(v);
      return isInternalSelected ? internalMatch : !internalMatch;
    });

    const mergedMap = new Map();
    independentVehicles.forEach((v) => {
      if (v.id) mergedMap.set(String(v.id), v);
    });
    dependentVehicles.forEach((v) => {
      if (v.id) mergedMap.set(String(v.id), v);
    });

    return Array.from(mergedMap.values());
  };

  // Compute filtered vehicle types dynamically when projectVehicles or fuelSourceWatch changes
  useEffect(() => {
    const eligibleVehicles = getModalEligibleVehiclesList();

    const uniqueVehicleTypes = Array.from(
      new Map(
        eligibleVehicles
          .filter((v) => v.vehicleTypeId)
          .map((v) => [
            String(v.vehicleTypeId),
            { id: v.vehicleTypeId, vehicleType: v.vehicleType },
          ])
      ).values()
    );

    setVehicleTypes(uniqueVehicleTypes);

    // Reset logic using refs to detect user manual changes
    if (lastFuelSourceRef.current !== null && fuelSourceWatch !== lastFuelSourceRef.current) {
      setValue("vehicleTypeId", "");
      setValue("vehicleId", "");
      lastFuelSourceRef.current = fuelSourceWatch;
      lastVehicleTypeRef.current = "";
    } else {
      const hasType = uniqueVehicleTypes.some(t => String(t.id) === String(vehicleTypeWatch));
      if (!hasType && !editData) {
        setValue("vehicleTypeId", "");
        setValue("vehicleId", "");
      }
      lastFuelSourceRef.current = fuelSourceWatch;
    }
  }, [projectVehicles, allActiveVehicles, fuelSourceWatch, vehicleTypeWatch, setValue, editData]);

  // Update vehicles select dropdown when vehicleTypeId or projectVehicles or fuelSourceWatch changes
  useEffect(() => {
    if (!vehicleTypeWatch) {
      setVehicles([]);
      if (lastVehicleTypeRef.current !== null && lastVehicleTypeRef.current !== "") {
        setValue("vehicleId", "");
      } else if (!editData) {
        setValue("vehicleId", "");
      }
      lastVehicleTypeRef.current = "";
      return;
    }

    const eligibleVehicles = getModalEligibleVehiclesList();
    const filteredVehicles = eligibleVehicles.filter(
      (v) => String(v.vehicleTypeId) === String(vehicleTypeWatch)
    );

    setVehicles(filteredVehicles);

    // Reset logic using refs to detect user manual changes
    if (lastVehicleTypeRef.current !== null && String(vehicleTypeWatch) !== String(lastVehicleTypeRef.current)) {
      setValue("vehicleId", "");
      lastVehicleTypeRef.current = String(vehicleTypeWatch);
    } else {
      const hasVehicle = filteredVehicles.some(v => String(v.id) === String(vehicleWatch));
      if (!hasVehicle && !editData) {
        setValue("vehicleId", "");
      }
      lastVehicleTypeRef.current = String(vehicleTypeWatch);
    }
  }, [vehicleTypeWatch, projectVehicles, allActiveVehicles, fuelSourceWatch, vehicleWatch, setValue, editData]);


  const loadVendorCategories = async () => {
    try {
      const res = await VendorCategoryService.getActive();
      const list = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
      setVendorCategories(list);
    } catch {
      setVendorCategories([]);
    }
  };

  const loadVendors = async () => {

    try {
      const res = await VendorService.getByCategory(1);
      const list = Array.isArray(res?.data) ? res.data : [];
      setVendors(list);
      return list;
    } catch {
      setVendors([]);
      return [];
    }
  };


  // useEffect(() => {
  //   if (vendorCatWatch) {
  //     loadVendors(vendorCatWatch);
  //     setValue("vendorId", "");
  //   } else {
  //     setVendors([]);
  //   }
  // }, [vendorCatWatch, setValue]);


  const loadAllActiveVehicles = async () => {
    try {
      const res = await VehicleRegistrationService.getActiveVehicles();
      const list = res?.status ? res.data : res?.data || res || [];
      setAllActiveVehicles(list);
    } catch (err) {
      console.error("Error loading all active vehicles:", err);
      setAllActiveVehicles([]);
    }
  };

  useEffect(() => {
    loadProjects();
    loadVendorCategories();
    loadAllActiveVehicles();
  }, []);

  // useEffect(() => {
  //   if (fuelSourceWatch === "INTERNAL") {
  //     setValue("amount", 0);
  //     setRecentFuelRate(null);
  //   } else {
  //     setValue("amount", "");
  //   }
  // }, [fuelSourceWatch, setValue]);

  // useEffect(() => {
  //   const calculateAmountFromRecentPurchase = async () => {
  //     const liters = Number(fuelQuantityWatch);

  //     if (
  //       fuelSourceWatch !== "EXTERNAL" ||
  //       !fuelEntryDateWatch ||
  //       !fuelTypeWatch ||
  //       !Number.isFinite(liters) ||
  //       liters <= 0
  //     ) {
  //       if (fuelSourceWatch === "EXTERNAL") {
  //         setRecentFuelRate(null);
  //         setValue("amount", "");
  //       }
  //       return;
  //     }

  //     try {
  //       const res = await FuelPurchaseService.getAll({
  //         type: fuelTypeWatch,
  //       });

  //       const entryDate = new Date(fuelEntryDateWatch);
  //       const purchases = Array.isArray(res?.data) ? res.data : [];
  //       const recentPurchase = purchases.find((purchase) => {
  //         if (!purchase?.purchaseDate) return false;
  //         return new Date(purchase.purchaseDate) <= entryDate;
  //       });
  //       const rate = Number(recentPurchase?.costperLiter);

  //       if (!Number.isFinite(rate) || rate <= 0) {
  //         setRecentFuelRate(null);
  //         setValue("amount", "");
  //         return;
  //       }

  //       setRecentFuelRate(rate);
  //       setValue("amount", Number((liters * rate).toFixed(2)), {
  //         shouldValidate: true,
  //         shouldDirty: true,
  //       });
  //     } catch (err) {
  //       console.error("Error loading recent fuel purchase rate:", err);
  //       setRecentFuelRate(null);
  //       setValue("amount", "");
  //     }
  //   };

  //   calculateAmountFromRecentPurchase();
  // }, [fuelSourceWatch, fuelEntryDateWatch, fuelTypeWatch, fuelQuantityWatch, setValue]);

  useEffect(() => {
    const calculateAmountFromRecentPurchase = async () => {

      const liters = Number(fuelQuantityWatch);

      if (
        !fuelEntryDateWatch ||
        !fuelTypeWatch ||
        !Number.isFinite(liters) ||
        liters <= 0 ||
        !selectedProjectId
      ) {
        setRecentFuelRate(null);
        setValue("amount", "");
        return;
      }

      try {
        const res = await FuelPurchaseService.getAll({
          projectId: selectedProjectId,
          type: fuelTypeWatch,
        });

        const purchases = Array.isArray(res?.data)
          ? res.data
          : [];

        const entryDate = new Date(fuelEntryDateWatch);

        // ✅ Filter solely by date (project and fuel type are already filtered by service query parameters)
        const filteredPurchases = purchases.filter((p) =>
          new Date(p.purchaseDate) <= entryDate
        );

        let recentPurchase = null;
        if (filteredPurchases.length > 0) {
          // Sort descending by purchaseDate first to get the latest date at the top
          const sortedByDate = [...filteredPurchases].sort(
            (a, b) => new Date(b.purchaseDate) - new Date(a.purchaseDate)
          );

          // Get the latest date string
          const latestDateStr = new Date(sortedByDate[0].purchaseDate).toDateString();

          // Get all purchases on that exact latest date
          const latestDayPurchases = sortedByDate.filter(
            (p) => new Date(p.purchaseDate).toDateString() === latestDateStr
          );

          // Select the one with the highest costperLiter (higher price rate)
          recentPurchase = latestDayPurchases.sort(
            (a, b) => Number(b.costperLiter) - Number(a.costperLiter)
          )[0];
        }

        const rate = Number(recentPurchase?.costperLiter);

        if (!Number.isFinite(rate) || rate <= 0) {
          setRecentFuelRate(null);
          setValue("amount", "");

          // Show user-friendly error message when no rate is found
          setMessage(
            "No active fuel purchase rate found for the selected Fuel Type on or before this date. Please ensure a Fuel Purchase record exists."
          );
          setMsgType("error");
          return;
        }

        // Clear rate error message if we successfully got a rate
        setMessage("");
        setRecentFuelRate(rate);

        setValue(
          "amount",
          Number((liters * rate).toFixed(2)),
          {
            shouldValidate: true,
            shouldDirty: true,
          }
        );

      } catch (err) {
        console.error(err);
        setRecentFuelRate(null);
        setValue("amount", "");
        setMessage("Error searching for fuel purchase rate.");
        setMsgType("error");
      }
    };

    calculateAmountFromRecentPurchase();

  }, [
    fuelSourceWatch,
    fuelEntryDateWatch,
    fuelTypeWatch,
    fuelQuantityWatch,
    selectedProjectId,
    setValue
  ]);

  useEffect(() => {
    if (showModal && selectedProjectId && fuelEntryDateWatch) {
      loadVehicles(selectedProjectId, fuelEntryDateWatch);
    }
  }, [fuelEntryDateWatch, showModal, selectedProjectId]);

  // useEffect(() => {
  //   const loadVoucher = async () => {
  //     if (fuelSourceWatch === "INTERNAL") {
  //       try {
  //         const comp = StorageService.activeCompany();

  //         const res = await DailyFuelEntryService.getNextVoucher({
  //           companyId: comp.companyId
  //         });

  //         setValue("vocherNo", res); // real value
  //       } catch (err) {
  //         console.error(err);
  //         setValue("vocherNo", "");
  //       }
  //     } else {
  //       setValue("vocherNo", "");
  //     }
  //   };

  //   loadVoucher();
  // }, [fuelSourceWatch, setValue]);

  useEffect(() => {

    const loadVoucher = async () => {
      // ✅ only for ADD mode (editData is null)
      if (editData) {
        return;
      }

      if (!fuelSourceWatch || !selectedProjectId) {
        return;
      }

      const previousFuelSource = previousFuelSourceRef.current;
      const sourceChanged = previousFuelSource !== fuelSourceWatch;

      if (sourceChanged || !previousFuelSource) {
        try {
          const comp = StorageService.activeCompany();

          const res = await DailyFuelEntryService.getNextVoucher({
            companyId: comp.companyId,
            projectId: selectedProjectId,
            fuelSource: fuelSourceWatch,
          });

          setValue("vocherNo", res, {
            shouldValidate: true,
            shouldDirty: true,
          });
          previousFuelSourceRef.current = fuelSourceWatch;

        } catch (err) {
          console.error(err);
          setValue("vocherNo", "", {
            shouldValidate: true,
            shouldDirty: true,
          });
          previousFuelSourceRef.current = fuelSourceWatch;
        }
      }
    };

    loadVoucher();

  }, [fuelSourceWatch, setValue, selectedProjectId, editData]);
  const loadProjectEntries = async (projectId) => {
    if (!projectId) {
      setEntries([]);
      setCurrentPage(1);
      return;
    }

    try {
      const res = await DailyFuelEntryService.getByProject(projectId);

      if (res?.status && Array.isArray(res.data)) {
        const sorted = [...res.data].sort(
          (a, b) => new Date(b.fuelEntryDate || 0) - new Date(a.fuelEntryDate || 0) || (b.id || 0) - (a.id || 0)
        );
        setEntries(sorted);
        setCurrentPage(1);
      } else {
        setEntries([]);
        setCurrentPage(1);
      }
    } catch (err) {
      console.error("Error loading project entries:", err);
      setEntries([]);
      setCurrentPage(1);
    }
  };

  useEffect(() => {
    let data = [...entries].sort(
      (a, b) => new Date(b.fuelEntryDate || 0) - new Date(a.fuelEntryDate || 0) || (b.id || 0) - (a.id || 0)
    );

    if (filterVehicleId) {
      data = data.filter(
        (e) => String(e.vehicleId) === String(filterVehicleId)
      );
    }

    if (filterFromDate) {
      data = data.filter(
        (e) => new Date(e.fuelEntryDate.split("T")[0]) >= new Date(filterFromDate)
      );
    }

    if (filterToDate) {
      data = data.filter(
        (e) => new Date(e.fuelEntryDate.split("T")[0]) <= new Date(filterToDate)
      );
    }

    setFilteredEntries(data);
    setCurrentPage(1);
  }, [filterVehicleId, filterFromDate, filterToDate, entries]);

  useEffect(() => {
    const sum = filteredEntries.reduce((acc, e) => acc + (Number(e.amount) || 0), 0);
    setTotalAmount(sum.toFixed(3));
  }, [filteredEntries]);


  const openAddModal = async () => {
    setEditData(null);
    previousFuelSourceRef.current = "EXTERNAL";
    lastFuelSourceRef.current = "EXTERNAL";
    lastVehicleTypeRef.current = "";

    let initialVoucher = "";
    try {
      const comp = StorageService.activeCompany();
      initialVoucher = await DailyFuelEntryService.getNextVoucher({
        companyId: comp.companyId,
        projectId: selectedProjectId,
        fuelSource: "EXTERNAL",
      });
    } catch (err) {
      console.error("Error pre-fetching external voucher:", err);
    }

    reset({
      fuelSource: "EXTERNAL",
      fuelType: "",
      fuelQuantityLiters: "",
      vehicleTypeId: "",
      vehicleId: "",
      vendorCategoryId: null,
      vendorId: null,
      vocherNo: initialVoucher,
      fuelEntryDate: getTodayDate(),
      amount: "",
      fromReading: "",
      Notes: "",
    });
    setShowModal(true);
    setReceiptPreview(null);
    setReceiptPreviewOld(null);
  };

  const editEntry = async () => {
    if (!selectedEntry) {
      setMessage("Please select a record to modify.");
      setMsgType("error");
      return;
    }

    // 🔐 ROLE CHECK
    const isPrivileged =
      emp.roleName === "Super Admin" ||
      emp.roleName === "SuperAdmin" ||
      Number(emp.roleId) === 1 ||
      emp.roleName === "Data Admin" ||
      emp.roleName === "DataAdmin" ||
      Number(emp.roleId) === 2;

    if (!isPrivileged) {
      // 🔒 NORMAL USER → CAN MODIFY ONLY TODAY
      const today = new Date();
      const entryDate = new Date(selectedEntry.fuelEntryDate);

      const todayStr =
        today.getFullYear() +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(today.getDate()).padStart(2, "0");

      const entryDateStr =
        entryDate.getFullYear() +
        "-" +
        String(entryDate.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(entryDate.getDate()).padStart(2, "0");

      if (todayStr !== entryDateStr) {
        setMessage("You can modify only today's fuel entry.");
        setMsgType("error");
        return;
      }
    }

    try {
      // ✅ FETCH FULL RECORD FROM BACKEND
      const res = await DailyFuelEntryService.getById(selectedEntry.id);
      const row = res.data;

      const entryDate = row.fuelEntryDate
        ? row.fuelEntryDate.split("T")[0]
        : getTodayDate();

      // ✅ Load project vehicles based on the fuel entry date
      await loadVehicles(row.projectId, entryDate);

      setEditData(row);
      previousFuelSourceRef.current = row.fuelSource || "EXTERNAL";
      lastFuelSourceRef.current = row.fuelSource || "EXTERNAL";
      lastVehicleTypeRef.current = String(row.vehicleTypeId || "");

      // ✅ IMAGE PREVIEW (OLD IMAGE)
      if (row.fuelReceiptURL) {
        setReceiptPreviewOld(row.fuelReceiptURL);
        setReceiptPreview(
          `${configSettings.appURL}/uploads/dailyFuelEntry/${row.fuelReceiptURL}`
        );
      } else {
        setReceiptPreview(null);
        setReceiptPreviewOld(null);
      }

      // ✅ SET FORM VALUES
      reset({
        fuelSource: row.fuelSource || "EXTERNAL",
        vehicleTypeId: row.vehicleTypeId ? String(row.vehicleTypeId) : "",
        vehicleId: row.vehicleId ? String(row.vehicleId) : "",
        vendorCategoryId: row.vendorCategoryId || null,
        vendorId: row.vendorId || null,
        vocherNo: row.vocherNo || "",
        fuelEntryDate: row.fuelEntryDate
          ? row.fuelEntryDate.split("T")[0]
          : getTodayDate(),
        amount: row.amount || "",
        fromReading: row.fromReading ?? "",
        Notes: row.Notes || "",
        fuelType: row.fuelType || "",                 // ✅ ADD
        fuelQuantityLiters: row.fuelQuantityLiters || "", // ✅ ADD
      });

      setShowModal(true);
    } catch (err) {
      console.error("Error loading fuel entry", err);
    }
  };


  const handleSave = async () => {

    const formData = watch();
    delete formData.vocherNo;

    if (!can("canAdd")) {
      setMessage("No permission");
      return;
    }
    const selectedDateStr = formData.fuelEntryDate;
    const todayStr = getTodayDate();

    if (selectedDateStr > todayStr) {
      setMessage("Future date is not allowed");
      setMsgType("error");
      return;
    }

    const isPrivileged =
      emp?.roleName === "Super Admin" ||
      emp?.roleName === "SuperAdmin" ||
      emp?.roleName === "Data Admin" ||
      emp?.roleName === "DataAdmin" ||
      Number(emp?.roleId) === 1 ||
      Number(emp?.roleId) === 2;

    if (!isPrivileged && selectedDateStr < todayStr) {
      setMessage("Only Super Admin and Data Admin can select a past date");
      setMsgType("error");
      return;
    }

    setLoading(true);
    try {
      await DailyFuelEntryService.create({
        ...formData,
        projectId: Number(selectedProjectId),
        vocherNo: formData.vocherNo,
        fuelReceiptURL: receiptPreview,
        roleId: Number(StorageService.loginData()?.roleId),
      });

      setMessage("Saved successfully");
      setMsgType("success");

      await loadProjectEntries(selectedProjectId);
      setShowModal(false);
      setSelectedEntry(null);
      lastFuelSourceRef.current = null;
      lastVehicleTypeRef.current = null;
    } catch (err) {
      const msg =
        err?.response?.data?.message || "Error saving entry";

      setMessage(msg);
      setMsgType("error");
    }
    setLoading(false);
  };


  // const handleUpdate = async () => {
  //   if (!can("canModify")) {
  //     setMessage("No permission");
  //     return;
  //   }
  //   const formData = watch();
  //   const selectedDate = new Date(formData.fuelEntryDate);
  //   const today = new Date(getTodayDate());

  //   if (selectedDate > today) {
  //     setMessage("Future date not allowed");
  //     setMsgType("error");
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     await DailyFuelEntryService.update(editData.id, {
  //       ...formData,
  //       projectId: Number(selectedProjectId),
  //       vocherNo: formData.vocherNo,
  //       fuelReceiptURL: receiptPreview,
  //       fuelReceiptURLOld: receiptPreviewOld,
  //     });

  //     setMessage("Updated successfully");
  //     setMsgType("success");

  //     await loadProjectEntries(selectedProjectId);
  //     setShowModal(false);
  //     setSelectedEntry(null);
  //   } catch (err) {
  //     const msg =
  //       err?.response?.data?.message || "Error updating entry";

  //     setMessage(msg);
  //     setMsgType("error");
  //   }
  //   setLoading(false);
  // };

  const handleUpdate = async () => {

    if (!can("canModify")) {
      setMessage("No permission");
      return;
    }

    const formData = watch();

    const selectedDateStr = formData.fuelEntryDate;
    const todayStr = getTodayDate();

    if (selectedDateStr > todayStr) {
      setMessage("Future date is not allowed");
      setMsgType("error");
      return;
    }

    const isPrivileged =
      emp?.roleName === "Super Admin" ||
      emp?.roleName === "SuperAdmin" ||
      emp?.roleName === "Data Admin" ||
      emp?.roleName === "DataAdmin" ||
      Number(emp?.roleId) === 1 ||
      Number(emp?.roleId) === 2;

    if (!isPrivileged && selectedDateStr < todayStr) {
      setMessage("Only Super Admin and Data Admin can select a past date");
      setMsgType("error");
      return;
    }

    setLoading(true);
    try {
      await DailyFuelEntryService.update(editData.id, {
        ...formData,
        projectId: Number(selectedProjectId),
        fuelReceiptURL: receiptPreview,
        fuelReceiptURLOld: receiptPreviewOld,
        roleId: Number(StorageService.loginData()?.roleId),
      });

      setMessage("Updated successfully");
      setMsgType("success");

      await loadProjectEntries(selectedProjectId);
      setShowModal(false);
      setSelectedEntry(null);
      lastFuelSourceRef.current = null;
      lastVehicleTypeRef.current = null;
    } catch (err) {
      const msg = err?.response?.data?.message || "Error updating entry";
      setMessage(msg);
      setMsgType("error");
    }
    setLoading(false);
  };

  const handleCancel = () => {
    setMessage("");
    setShowModal(false);
    setEditData(null);
    setSelectedEntry(null);
    setReceiptPreview(null);
    setReceiptPreviewOld(null);
    lastFuelSourceRef.current = null;
    lastVehicleTypeRef.current = null;
    reset({
      vehicleId: "",
      vehicleTypeId: "",
      vendorCategoryId: null,
      vendorId: null,
      vocherNo: "",
      fuelEntryDate: getTodayDate(),
      amount: "",
      fromReading: "",   //  add this
      Notes: "",
    });
  };

  const handleReceiptUpload = (e) => {
    utility.readFile(e, setReceiptPreview, "fuelReceiptURL");
  };


  const toggleStatus = async (entry) => {
    if (!can("canModify")) {
      setMessage("No permission");
      return;
    }
    const newStatus = entry.status === "Active" ? "Inactive" : "Active";
    if (!window.confirm(`Are you sure you want to change status to ${newStatus}?`)) return;

    setLoading(true);
    try {
      await DailyFuelEntryService.updateStatus(entry.id);
      setMessage("Status updated successfully");
      setMsgType("success");
      await loadProjectEntries(selectedProjectId);
    } catch (err) {
      setMessage("Failed to update status");
      setMsgType("error");
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("You need to delete this record?")) return;

    try {
      await DailyFuelEntryService.remove(id);
      setMessage("Deleted successfully");
      setMsgType("success");
      setSelectedEntry(null);
      await loadProjectEntries(selectedProjectId);
    } catch (err) {
      console.error(err);
      setMessage("Error deleting entry");
      setMsgType("error");
    }
  };

  // const getOwnershipDisplay = (row) => {
  //   if (!row) return "";

  //   const ownership = row.ownerShipType;

  //   if (ownership && ownership.toLowerCase() === "lease") {
  //     return row.vehicleVendorName || "";
  //   }

  //   return ownership || "";
  // };
  const getOwnershipDisplay = (row) => {
    if (!row) return "";

    const ownership = row.ownerShipType;

    if (ownership?.toLowerCase() === "lease") {
      return `Lease - ${row.vendorName || ""}`; // ✅ UPDATED
    }

    return ownership || "";
  };

  return (
    <>
      <Breadcrumb pageTitle="Daily Fuel Entry" secondTitle="Fuel" />


      <MessageDialog
        message={message}
        type={msgType}
        setMessage={setMessage}
        setMsgType={setMsgType}
      />

      <div className="row">
        <div className="card p-3 mb-3 d-flex gap-3 flex-wrap align-items-end flex-row">
          {/* PROJECT */}
          <div style={{ minWidth: "280px" }}>
            <label className="form-label mb-1">Project</label>
            <Select
              options={projects.map((p) => ({
                value: String(p.id),
                label: `${p.projectName} - ${p.projectCode}`
              }))}
              value={
                selectedProjectId
                  ? {
                      value: String(selectedProjectId),
                      label: (() => {
                        const p = projects.find((x) => String(x.id) === String(selectedProjectId));
                        return p ? `${p.projectName} - ${p.projectCode}` : "";
                      })()
                    }
                  : null
              }
              onChange={async (opt) => {
                const pid = opt ? opt.value : "";
                setSelectedProjectId(pid);
                setSelectedEntry(null);
                setFilterVehicleId("");
                setFilterFromDate("");
                setFilterToDate("");
                setValue("vehicleTypeId", "");
                setValue("vehicleId", "");
                if (pid) {
                  await loadFilterVehicles(pid);
                  await loadVehicles(pid);
                  await loadProjectEntries(pid);
                } else {
                  setFilterVehicles([]);
                  setProjectVehicles([]);
                  setEntries([]);
                  setFilteredEntries([]);
                  setTotalAmount(0);
                }
              }}
              isSearchable={true}
              isClearable={true}
              placeholder="Select Project"
              classNamePrefix="react-select"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                control: (base) => ({ ...base, minHeight: "38px" })
              }}
            />
          </div>

          {/* VEHICLE NO FILTER */}
          <div style={{ width: "240px" }}>
            <label className="form-label mb-1">Vehicle</label>
            <select
              className="form-select"
              value={filterVehicleId}
              onChange={(e) => setFilterVehicleId(e.target.value)}
              disabled={!selectedProjectId}
            >
              <option value="">All Vehicles</option>
              {filterVehicleOptions.map((v) => (
                <option key={v.id} value={v.id}>
                  {v.vehicleType ? `(${v.vehicleType}) --- ` : ""}{v.vehicleName} - {v.registrationNo}
                </option>
              ))}
            </select>
          </div>

          {/* FROM DATE */}
          <div style={{ width: "160px" }}>
            <label className="form-label mb-1">From Date</label>
            <input
              type="date"
              className="form-control"
              value={filterFromDate}
              onChange={(e) => {
                setFilterFromDate(e.target.value);
                setFilterToDate("");
              }}
              disabled={!selectedProjectId}
            />
          </div>

          {/* TO DATE */}
          <div style={{ width: "160px" }}>
            <label className="form-label mb-1">To Date</label>
            <input
              type="date"
              className="form-control"
              value={filterToDate}
              onChange={(e) => {
                const val = e.target.value;
                if (filterFromDate && val && new Date(val) < new Date(filterFromDate)) {
                  setMessage("To Date must be greater than or equal to From Date");
                  setMsgType("error");
                  setFilterToDate("");
                  return;
                }
                setFilterToDate(val);
              }}
              disabled={!selectedProjectId}
            />
          </div>

          {/* TOTAL AMOUNT */}
          <div style={{ width: "160px" }}>
            <label className="form-label mb-1">Total Amount</label>
            <input
              type="text"
              className="form-control"
              value={`₹ ${totalAmount}`}
              disabled
            />
          </div>
        </div>

        {/* TABLE CARD */}
        <div className="card">
          <div className="card-header d-flex justify-content-end align-items-center">
            <div className="d-flex gap-2">
              {can("canModify") && (
                <button
                  className="btn btn-warning"
                  disabled={!selectedEntry}
                  onClick={editEntry}
                >
                  <i className="ti ti-pencil me-1"></i> Modify
                </button>
              )}

              {can("canAdd") && (
                <button
                  className="btn btn-success"
                  disabled={!selectedProjectId}
                  onClick={openAddModal}
                >
                  <i className="ti ti-plus me-1"></i> Add Entry
                </button>
              )}
            </div>
          </div>

          <div className="card-body">
            {/* {message && (
              <div className={`alert alert-${msgType} py-2`}>{message}</div>
            )} */}
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th style={{ width: 40 }}></th>
                  <th>Date</th>
                  <th>Project</th>
                  <th>Vehicle Name</th>
                  <th>Vehicle No</th>
                  <th>Fuel Type</th>
                  <th className="text-end">Liters</th>
                  <th className="text-end">Rate / Liter</th>
                  <th className="text-end">Amount</th>
                  <th>Receipt</th>
                  {can("canReject") && <th>Action</th>}
                </tr>
              </thead>

              <tbody>
                {filteredEntries.length > 0 ? (
                  filteredEntries.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((e) => (
                    <tr
                      key={e.id}
                      className={selectedEntry?.id === e.id ? "table-active" : ""}
                    >
                      <td className="text-center align-middle">
                        <input
                          type="radio"
                          checked={selectedEntry?.id === e.id}
                          onChange={(ev) => {
                            ev.stopPropagation();
                            if (ev.target.checked) setSelectedEntry(e);
                            else setSelectedEntry(null);
                          }}
                        />
                      </td>
                      <td className="align-middle">
                        {utility.formatDateDDMMMYYYY(e.fuelEntryDate)}
                      </td>
                      <td className="align-middle">{e.projectName}</td>
                      <td className="align-middle">{e.vehicleName}</td>
                      <td className="align-middle">{e.registrationNo}</td>
                      <td className="align-middle">{e.fuelType || "-"}</td>
                      <td className="align-middle text-end">{e.fuelQuantityLiters || 0}</td>
                      <td className="align-middle text-end">{e.fuelQuantityLiters ? `₹ ${(Number(e.amount) / Number(e.fuelQuantityLiters)).toFixed(2)}` : "-"}</td>
                      <td className="align-middle text-end">₹ {e.amount}</td>
                      <td className="align-middle">
                        {e.fuelReceiptURL ? (
                          <a
                            href={`${configSettings.mediaURL}/get/dailyFuelEntry/${e.fuelReceiptURL}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            View
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                      {can("canReject") && (
                        <td className="text-center align-middle">
                          {(() => {
                            const isDeletable = isAdmin || e.fuelEntryDate?.split("T")[0] === `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, "0")}-${String(new Date().getDate()).padStart(2, "0")}`;
                            return (
                              <button
                                className="btn btn-danger btn-sm"
                                title={isDeletable ? "Delete" : "Only today's records can be deleted"}
                                style={{
                                  opacity: isDeletable ? 1 : 0.4,
                                  cursor: isDeletable ? "pointer" : "not-allowed"
                                }}
                                disabled={!isDeletable}
                                onClick={(evt) => {
                                  evt.stopPropagation();
                                  if (isDeletable) {
                                    handleDelete(e.id);
                                  }
                                }}
                              >
                                <i className="ti ti-trash"></i>
                              </button>
                            );
                          })()}
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={can("canReject") ? 11 : 10} className="text-center text-muted">
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <ReactPaginate
              forcePage={Math.max(0, currentPage - 1)}
              breakLabel="..."
              nextLabel="Next >"
              previousLabel="< Previous"
              onPageChange={(e) => setCurrentPage(e.selected + 1)}
              pageCount={Math.ceil(filteredEntries.length / itemsPerPage) || 1}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              containerClassName="pagination-container"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              activeClassName="active"
            />
          </div>
        </div>

        {/* MODAL */}
        {showModal && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.5)",
              zIndex: 999,
            }}
          >
            <div
              style={{
                position: "fixed",
                top: "13%",
                left: "57%",
                transform: "translate(-50%)",
                width: "82%",
                maxWidth: "950px",
                maxHeight: "92vh",
                overflowY: "auto",
                padding: "12px 16px",
                background: "#fff",
                borderRadius: "8px",
              }}
            >
              <h5 className="mb-2">
                {editData ? "Modify Fuel Entry" : "Add Fuel Entry"}
              </h5>

              {/* {message && (
                <div className={`alert alert-${msgType} py-2`}>{message}</div>
              )} */}

              {/* 2 COLUMN GRID FORM */}
              <div className="row">
                {/* Fuel Entry Date */}
                <div className="col-md-6 mb-1">
                  <label className="form-label mb-1">
                    Fuel Entry Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className={`form-control ${errors.fuelEntryDate ? "is-invalid" : ""}`}
                    {...register("fuelEntryDate", {
                      required: "Fuel Entry Date is required",
                      validate: (value) => {
                        const selected = value; // yyyy-mm-dd
                        const today = new Date().toLocaleDateString("en-CA"); // yyyy-mm-dd

                        if (selected > today) {
                          return "Future date is not allowed";
                        }

                        const emp = StorageService.loginData();
                        const isPrivileged =
                          emp?.roleName === "Super Admin" ||
                          emp?.roleName === "SuperAdmin" ||
                          emp?.roleName === "Data Admin" ||
                          emp?.roleName === "DataAdmin" ||
                          Number(emp?.roleId) === 1 ||
                          Number(emp?.roleId) === 2;

                        if (!isPrivileged && selected < today) {
                          return "Only Super Admin and Data Admin can select a past date";
                        }
                        return true;
                      }
                    })}
                  />
                  {errors.fuelEntryDate && (
                    <small className="text-danger">
                      {errors.fuelEntryDate.message}
                    </small>
                  )}
                </div>

                {/* Fuel Source */}
                <div className="col-md-6 mb-1">
                  <label className="form-label mb-1">
                    Fuel Source <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    {...register("fuelSource", { required: "Fuel Source required" })}
                  >
                    <option value="EXTERNAL">External</option>
                    <option value="INTERNAL">Internal</option>
                  </select>
                  {errors.fuelSource && (
                    <small className="text-danger">
                      {errors.fuelSource.message}
                    </small>
                  )}
                </div>

                {/* Voucher No */}
                <div className="col-md-6 mb-1">
                  <label className="form-label mb-1">
                    VoucherNo <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.vocherNo ? "is-invalid" : ""}`}
                    {...register("vocherNo", {
                      required: "Voucher No is required",
                    })}
                    readOnly
                  />
                  {errors.vocherNo && (
                    <div className="invalid-feedback">
                      {errors.vocherNo.message}
                    </div>
                  )}
                </div>

                {/* Vehicle Type */}
                <div className="col-md-6 mb-1">
                  <label className="form-label mb-1">
                    Vehicle Type <span className="text-danger">*</span>
                  </label>
                  <select
                    key={editData ? `edit-${editData.id}-${vehicleTypes.map((v) => v.id).join(",")}` : "add"}
                    className="form-select"
                    {...register("vehicleTypeId", {
                      required: "Vehicle Type is required",
                    })}
                  >
                    <option value="">Select Vehicle Type</option>
                    {vehicleTypes.map((v) => (
                      <option key={v.id} value={v.id}>
                        {v.vehicleType}
                      </option>
                    ))}
                  </select>
                  {errors.vehicleTypeId && (
                    <small className="text-danger">
                      {errors.vehicleTypeId.message}
                    </small>
                  )}
                </div>

                {/* Vehicle */}
                <div className="col-md-6 mb-1">
                  <label className="form-label mb-1">
                    Vehicle <span className="text-danger">*</span>
                  </label>
                  <select
                    key={editData ? `edit-${editData.id}-${vehicles.map((v) => v.id).join(",")}` : "add"}
                    className="form-select"
                    disabled={!vehicleTypeWatch}
                    {...register("vehicleId", {
                      required: "Vehicle is required",
                    })}
                  >
                    <option value="">Select Vehicle</option>
                    {vehicles.map((v) => {
                      const displayName = v.ownerShipType?.toLowerCase() === "lease" ? v.vendorName : v.vehicleName;
                      return (
                        <option key={v.id} value={v.id}>
                          ({v.vehicleType}) - {v.ownerShipType} --- {displayName} - {v.registrationNo}
                        </option>
                      );
                    })}
                  </select>
                  {errors.vehicleId && (
                    <small className="text-danger">
                      {errors.vehicleId.message}
                    </small>
                  )}
                </div>

                {/* Ownership */}
                <div className="col-md-6 mb-1">
                  <label className="form-label mb-1">Ownership</label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("ownerShipType")}
                    readOnly
                    disabled
                  />
                </div>

                {/* Fuel Type */}
                <div className="col-md-6 mb-1">
                  <label className="form-label mb-1">
                    Fuel Type <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    {...register("fuelType", { required: "Fuel Type required" })}
                  >
                    <option value="">Select</option>
                    <option value="DIESEL">Diesel</option>
                    <option value="PETROL">Petrol</option>
                    <option value="GAS">Gas</option>
                    <option value="OIL">Oil</option>
                  </select>
                  {errors.fuelType && (
                    <small className="text-danger">{errors.fuelType.message}</small>
                  )}
                </div>

                {/* Quantity */}
                <div className="col-md-6 mb-1">
                  <label className="form-label mb-1">
                    Quantity (Liters) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    step="any"
                    className={`form-control ${errors.fuelQuantityLiters ? "is-invalid" : ""}`}
                    {...register("fuelQuantityLiters", {
                      required: "Quantity required",
                      valueAsNumber: true,
                      validate: (v) => v > 0 || "Must be greater than 0",
                    })}
                  />
                  {errors.fuelQuantityLiters && (
                    <div className="invalid-feedback">
                      {errors.fuelQuantityLiters.message}
                    </div>
                  )}
                </div>

                {/* Amount */}
                <div className="col-md-6 mb-1">
                  <label className="form-label mb-1">
                    Amount <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className={`form-control ${errors.amount ? "is-invalid" : ""}`}
                    step="any"
                    readOnly
                    {...register("amount", {
                      required: "Amount is required",
                      valueAsNumber: true,
                      validate: (value) => {
                        if (value <= 0) return "Amount must be greater than 0";
                        return true;
                      },
                    })}
                  />
                  {recentFuelRate && (
                    <small className="text-dark fw-bold d-block mt-1">
                      Rate: ₹ {recentFuelRate} / liter
                    </small>
                  )}
                  {errors.amount && (
                    <div className="invalid-feedback">
                      {errors.amount.message}
                    </div>
                  )}
                </div>

                {/* Fuel Receipt Image */}
                <div className="col-md-6 mb-1">
                  <label className="form-label mb-1">Fuel Receipt Image</label>
                  <input
                    type="file"
                    accept="image/*,.pdf"
                    className="form-control"
                    onChange={handleReceiptUpload}
                  />
                  {receiptPreview && (
                    (receiptPreview.startsWith("data:image/") || /\.(jpe?g|png|gif|webp|bmp)$/i.test(receiptPreview)) ? (
                      <img
                        src={receiptPreview}
                        alt="Receipt Preview"
                        className="mt-2 rounded"
                        width="120"
                        height="100"
                        style={{ objectFit: "cover" }}
                      />
                    ) : (
                      <div className="mt-2">
                        <a
                          href={receiptPreview}
                          target="_blank"
                          rel="noreferrer"
                          className="d-inline-flex align-items-center gap-1"
                          style={{ textDecoration: "none" }}
                        >
                          <span className="badge bg-secondary">PDF</span>
                          <span>View PDF</span>
                        </a>
                      </div>
                    )
                  )}
                </div>

                {/* Meter Reading */}
                <div className="col-md-6 mb-1">
                  <label className="form-label mb-1">Meter Reading</label>
                  <input
                    type="number"
                    min="0"
                    className={`form-control ${errors.fromReading ? "is-invalid" : ""}`}
                    placeholder="Enter Meter Reading"
                    {...register("fromReading", {
                      valueAsNumber: true,
                      validate: (value) => {
                        if (value === "" || value === undefined || value === null || isNaN(value)) return true;
                        if (value < 0) return "Negative values not allowed";
                        return true;
                      },
                    })}
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "e") {
                        e.preventDefault();
                      }
                    }}
                  />
                  {errors.fromReading && (
                    <div className="invalid-feedback">
                      {errors.fromReading.message}
                    </div>
                  )}
                </div>

                {/* Notes */}
                <div className="col-md-6 mb-1">
                  <label className="form-label mb-1">Notes</label>
                  <textarea
                    className="form-control"
                    rows={1}
                    style={{ height: "45px", resize: "none" }}
                    {...register("Notes")}
                  />
                </div>

                {/* Action Buttons */}
                <div className="col-12 mt-3 d-flex justify-content-end gap-2">
                  {editData ? (
                    can("canModify") && (
                      <button
                        className="btn btn-primary"
                        disabled={Object.keys(errors).length > 0 || loading}
                        onClick={handleSubmit(handleUpdate)}
                      >
                        <i className="ti ti-circle-check me-1"></i>
                        Update
                      </button>
                    )
                  ) : (
                    can("canAdd") && (
                      <button
                        className="btn btn-primary"
                        disabled={Object.keys(errors).length > 0 || loading}
                        onClick={handleSubmit(handleSave)}
                      >
                        <i className="ti ti-circle-check me-1"></i>
                        Save
                      </button>
                    )
                  )}
                  <button className="btn btn-secondary " onClick={handleCancel}>
                    <i className="ti ti-cancel me-1"></i>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
